<template>
  <div>
    <Modal
      v-model="serverSelectModal"
      title="选择固定资产"
      width="1000">
      <div>
        <span>已选固定资产(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptyServer" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'asset_id_' + index" @on-close="removeServer('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="100" ref="searchServerForm" :model="searchServerForm">
        <FormItem label="资产编号">
          <Input v-model="searchServerForm.asset_id" />
        </FormItem>
        <!-- <FormItem label="资产类型">
          <Select v-model="searchServerForm.asset_type">
            <Option v-for="item in all_type_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem> -->
        <!-- <FormItem label="状态" prop="status">
          <Select v-model="searchServerForm.status">
            <Option v-for="item in allStatusData" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem> -->
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getAssetsData()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetServerSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="serverError" type="warning" show-icon>获取固定资产列表失败</Alert>
        <Table
            border
            ref="tableData"
            :loading="TableLoading"
            :data="asset.data"
            :columns="asset.columns"
            size="small">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: right;">
              <page
                :total="asset.count"
                :current="asset.page"
                :page-size="asset.size"
                @on-change="getAssetsData"></page>
            </div>
          </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectServerOk">确定</Button>
        <Button @click="serverSelectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as cmdbRequestApi from '@/api/cmdb'
import { getAllOpsFLowTypes } from '@/api/cmdb'
import { getJsonLength } from './scriptTools'
import expandRow from '../table-expand.vue'
export default {
  name: 'select-server',
  components: { expandRow },
  data () {
    return {
      selectType: '',
      selectRow: [],
      selectServerIds: {},
      endSelectServer: {},
      endSelectServerLength: 0,
      all_type_list: [],
      // 选择目标固定资产
      TableLoading: false,
      serverError: false,
      serverSelectModal: false,
      single: false,
      selected: [],
      searchServerForm: {
        asset_id: '',
        asset_type: '',
        ordering: '',
        status: ''
      },
      assetParams: {},
      asset: {
        data: [],
        columns: [
          {
            type: 'expand',
            title: '更多',
            align: 'center',
            minWidth: 60,
            render: (h, params) => {
              return h('div', [
                h(expandRow, {
                  props: {
                    row: params.row.asset_info_dict
                  }
                })
              ])
            }
          },
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.asset_id) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.asset_id) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.asset.data[params.index].checkBox = e
                      if (e) {
                        if (this.single) {
                          this.emptyServer()
                        }
                        if (this.selectRow.indexOf(params.row.asset_id) < 0) {
                          this.selectRow.push(params.row.asset_id)
                          this.selectServerIds[params.row.asset_id] = params.row.id
                        }
                      } else {
                        this.removeServer(null, params.row.asset_id)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            title: '资产编号',
            minWidth: 100,
            align: 'center',
            key: 'asset_id'
          },
          {
            title: 'SN',
            align: 'center',
            minWidth: 90,
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['SN'])
            }
          },
          {
            title: '名称',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.asset_info_dict['名称'])
            }
          },
          {
            title: '资产类型',
            minWidth: 100,
            align: 'center',
            key: 'asset_type',
            render: (h, params) => {
              if (params.row.asset_type) {
                return h('span', params.row.asset_type.name)
              }
            }
          },
          {
            title: '关联资产',
            minWidth: 100,
            align: 'center',
            key: 'bind_asset'
          },
          {
            title: '操作人',
            minWidth: 100,
            align: 'center',
            key: 'operator_full_name'
          },
          {
            title: '操作时间',
            minWidth: 180,
            align: 'center',
            key: 'operate_time',
            render: (h, params) => {
              if (params.row.operate_time) {
                return h('div', moment(params.row.operate_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '采购日期',
            minWidth: 130,
            align: 'center',
            key: 'buy_time'
          },
          {
            title: '供应商',
            key: 'supplier',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              if (params.row.supplier) {
                return h('span', params.row.supplier.name)
              }
            }
          },
          {
            title: '保管人',
            minWidth: 100,
            align: 'center',
            key: 'use_person'
          },
          {
            title: '领用时间',
            minWidth: 180,
            align: 'center',
            key: 'use_time',
            render: (h, params) => {
              if (params.row.use_time) {
                return h('div', moment(params.row.use_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            minWidth: 80,
            align: 'center',
            key: 'status',
            render: (h, params) => {
              let statusTran = {
                1: '在库',
                2: '借出',
                3: '维修',
                4: '报废'
              }
              if (params.row.status) {
                return h('span', statusTran[params.row.status])
              }
            }
          },
          {
            title: '公司',
            align: 'center',
            minWidth: 180,
            key: 'tenant_name'
          },
          {
            title: '备注',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'remark'
          }
        ],
        count: 1,
        page: 1,
        size: 5
      },
      LogsModel: false,
      formDynamicIndex: 1,
      formDynamic: [],
      allUserData: [],
      searchForm: {
        server_id: '',
        asset_type: '',
        supplier: '',
        status: '',
        operator: '',
        use_person: '',
        asset_info: ''
      },
      typeChangeModal: false,
      typeTableLoading: false,
      typeChangeModalTitle: '添加资产类型',
      serverTableLoading: false,
      id: '',
      // 固定资产组
      zTreeSetting: {
        view: {
          selectedMulti: false
        },
        data: {
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'parent_id',
            rootPId: 0
          }
        },
        check: {
          enable: false
        },
        callback: {
          onClick: this.zTreeOnClick,
          onRightClick: this.OnRightClick
        }
      },
      zNodes: [{ 'id': 0, 'parent_id': 0, 'name': '所有主机', 'open': 'true' }]
    }
  },
  methods: {
    // 获取所有类型列表
    getAllOpsTypes (type) {
      this.all_type_list = []
      let params = {
        search: type
      }
      getAllOpsFLowTypes(params).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_type_list.push({ key: result[i].id, name: result[i].name })
        }
      })
    },
    getAssetsData (value = 1) {
      this.asset.page = value
      let params = this.searchServerForm
      params.size = this.asset.size
      params.page = this.asset.page
      this.TableLoading = true
      cmdbRequestApi.getOpsCenterAssets(params).then(res => {
        this.asset.data = res.data.results
        this.asset.count = res.data.count
        this.TableLoading = false
      }).catch(res => {
        this.TableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取资产列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取资产列表失败！服务器无响应'
          })
        }
      })
    },
    // 打开固定资产选择Modal
    openSelectServerModal (assetParams = {}, selectedServer = {}, single = false, type, status) {
      this.searchServerForm.asset_type = type
      this.searchServerForm.status = status
      this.assetParams = assetParams
      // this.getAllOpsTypes(type)
      this.getAssetsData()
      this.selectRow = []
      this.single = single
      for (let asset in selectedServer) {
        this.selectRow.push(asset)
        this.selectServerIds[asset] = selectedServer[asset]
      }
      this.serverSelectModal = true
    },
    // 重置搜索表单
    resetServerSearchForm () {
      this.searchServerForm.asset_id = ''
      this.getAssetsData()
    },
    // 移除选中的固定资产
    removeServer (event, name) {
      if (event) {
        for (let i in this.asset.data) {
          if (this.asset.data[i].asset_id === name) {
            this.asset.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(name)
      this.selectRow.splice(index, 1)
      this.selectServerIds[name] = null
    },
    // 清空选中的固定资产
    emptyServer () {
      this.selectServerIds = {}
      for (let i in this.asset.data) {
        this.asset.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择固定资产完成
    selectServerOk () {
      this.endSelectServer = {}
      for (let asset in this.selectServerIds) {
        if (this.selectServerIds[asset]) {
          this.endSelectServer[asset] = this.selectServerIds[asset]
        }
      }
      this.selectServerIds = {}
      this.selectRow = []
      this.endSelectServerLength = getJsonLength(this.endSelectServer)
      this.serverSelectModal = false
      this.$emit('selectServerComplete', this.endSelectServer, this.endSelectServerLength)
    }
  }
}
</script>

<style>
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
